import slider_1 from '../assets/images/home/slider_1.png'
import slider_2 from '../assets/images/home/slider_2.png'
import slider_3 from '../assets/images/home/slider_3.png'
import slider_4 from '../assets/images/home/slider_4.png'
import iconOpt_1 from '../assets/images/home/iconOpt_sales.png'
import iconOpt_2 from '../assets/images/home/iconOpt_deal.png'
import iconOpt_3 from '../assets/images/home/iconOpt_watchSale.png'
import iconOpt_4 from '../assets/images/home/iconOpt_news.png'
import password from 'secure-random-password'
import dienthoai from '../assets/images/header/dienthoai.png'
import laptop from '../assets/images/header/laptop.png'
import phukien from '../assets/images/header/phukien.png'
import smartwatch from '../assets/images/header/smartwatch.png'
import smarthome from '../assets/images/header/smarthome.png'
import tablet from '../assets/images/header/tablet.png'
import tv from '../assets/images/header/tv.png'
import watch from '../assets/images/header/watch.png'
import banner_block_apple from '../assets/images/block_item_product/banner_block_apple.png'
import banner_block_headphone from '../assets/images/block_item_product/banner_block_headphone.png'
import banner_block_battery from '../assets/images/block_item_product/banner_block_battery.png'
import banner_block_chargeCable from '../assets/images/block_item_product/banner_block_chargeCable.png'
import banner_block_gaming from '../assets/images/block_item_product/banner_block_gaming.png'
import banner_block_speaker from '../assets/images/block_item_product/banner_block_speaker.png'
import banner_block_smartHome from '../assets/images/block_item_product/banner_block_smartHome.png'

import banner_fashion from '../assets/images/smartWatch/banner_fashion.png'
import banner_utility from '../assets/images/smartWatch/banner_utility.png'
import banner_sport from '../assets/images/smartWatch/banner_sport.png'
import banner_children from '../assets/images/smartWatch/banner_children.png'
import banner_watch_chain from '../assets/images/smartWatch/banner_watch_chain.png'
import banner_block_healthycare from '../assets/images/block_item_product/banner_block_healthycare.png'
import banner_block_home from '../assets/images/block_item_product/banner_block_home.png'


export const banner_block_product_smart_watch = {
    banner_fashion,
    banner_sport,
    banner_utility,
    banner_children,
    banner_watch_chain,
}

export const banner_block_product = {
    banner_block_apple,
    banner_block_battery,
    banner_block_chargeCable,
    banner_block_gaming,
    banner_block_headphone,
    banner_block_smartHome,
    banner_block_speaker,
    banner_block_healthycare,
    banner_block_home
}

export const sliders_home = [
    {
        url: slider_1
    },
    {
        url: slider_2
    },
    {
        url: slider_3
    },
    {
        url: slider_4
    },
]

export const list_icon_opt_home = [
    {
        url: iconOpt_1,
        content: 'Giảm Online',
        link : 'giam-online'
    },
    {
        url: iconOpt_2,
        content: 'Top Deal',
        link : 'top-deal'
    },
    {
        url: iconOpt_3,
        content: 'Bão sale đồng hồ',
        link : 'bao-sale-dong-ho'
    },
    {
        url: iconOpt_4,
        content: '24h Công nghệ',
        link : '24h-cong-nghe'
    },
]




export const list_product= [
    {
        id: password.randomPassword({length:10}),
        name:'Acer Aspire A315 56 32TP i3 1005G1 (NX.HS5SV.00K)',
        priceOld:20000000,
        price:13000000,
        promotion:10,
        rating:5,
        imgUrl:'https://cdn.tgdd.vn/Products/Images/42/230529/iphone-13-pro-max-xanh-la-thumb-600x600.jpg',
        url:'/product-detail'
    },
    {
        id: password.randomPassword({length:10}),
        name:'Acer Aspire A315 56 32TP i3 1005G1 (NX.HS5SV.00K)',
        priceOld:20000000,
        price:13000000,
        promotion:10,
        rating:5,
        imgUrl:'https://cdn.tgdd.vn/Products/Images/42/230529/iphone-13-pro-max-xanh-la-thumb-600x600.jpg',
        url:'/product-detail'
    },
    {
        id: password.randomPassword({length:10}),
        name:'Acer Aspire A315 56 32TP i3 1005G1 (NX.HS5SV.00K)',
        priceOld:20000000,
        price:13000000,
        promotion:10,
        rating:5,
        imgUrl:'https://cdn.tgdd.vn/Products/Images/42/230529/iphone-13-pro-max-xanh-la-thumb-600x600.jpg',
        url:'/product-detail'
    },
    {
        id: password.randomPassword({length:10}),
        name:'Acer Aspire A315 56 32TP i3 1005G1 (NX.HS5SV.00K)',
        priceOld:20000000,
        price:13000000,
        promotion:10,
        rating:5,
        imgUrl:'https://cdn.tgdd.vn/Products/Images/42/230529/iphone-13-pro-max-xanh-la-thumb-600x600.jpg',
        url:'/product-detail'
    },
    {
        id: password.randomPassword({length:10}),
        name:'Acer Aspire A315 56 32TP i3 1005G1 (NX.HS5SV.00K)',
        priceOld:20000000,
        price:13000000,
        promotion:10,
        rating:5,
        imgUrl:'https://cdn.tgdd.vn/Products/Images/42/230529/iphone-13-pro-max-xanh-la-thumb-600x600.jpg',
        url:'/product-detail'
    },
    {
        id: password.randomPassword({length:10}),
        name:'Acer Aspire A315 56 32TP i3 1005G1 (NX.HS5SV.00K)',
        priceOld:20000000,
        price:13000000,
        promotion:10,
        rating:5,
        imgUrl:'https://cdn.tgdd.vn/Products/Images/42/230529/iphone-13-pro-max-xanh-la-thumb-600x600.jpg',
        url:'/product-detail'
    },
    {
        id: password.randomPassword({length:10}),
        name:'Acer Aspire A315 56 32TP i3 1005G1 (NX.HS5SV.00K)',
        priceOld:20000000,
        price:13000000,
        promotion:10,
        rating:5,
        imgUrl:'https://cdn.tgdd.vn/Products/Images/42/230529/iphone-13-pro-max-xanh-la-thumb-600x600.jpg',
        url:'/product-detail'
    },
    {
        id: password.randomPassword({length:10}),
        name:'Acer Aspire A315 56 32TP i3 1005G1 (NX.HS5SV.00K)',
        priceOld:20000000,
        price:13000000,
        promotion:10,
        rating:5,
        imgUrl:'https://cdn.tgdd.vn/Products/Images/42/230529/iphone-13-pro-max-xanh-la-thumb-600x600.jpg',
        url:'/product-detail'
    },
    {
        id: password.randomPassword({length:10}),
        name:'Acer Aspire A315 56 32TP i3 1005G1 (NX.HS5SV.00K)',
        priceOld:20000000,
        price:13000000,
        promotion:10,
        rating:5,
        imgUrl:'https://cdn.tgdd.vn/Products/Images/42/230529/iphone-13-pro-max-xanh-la-thumb-600x600.jpg',
        url:'/product-detail'
    },
    {
        id: password.randomPassword({length:10}),
        name:'Acer Aspire A315 56 32TP i3 1005G1 (NX.HS5SV.00K)',
        priceOld:20000000,
        price:13000000,
        promotion:10,
        rating:5,
        imgUrl:'https://cdn.tgdd.vn/Products/Images/42/230529/iphone-13-pro-max-xanh-la-thumb-600x600.jpg',
        url:'/product-detail'
    },
]


export const categories = [
    {
      id: 1,
      icon: dienthoai,
      content: 'Điện thoại',
      link:'dien-thoai'
    },
    {
      id: 2,
      icon: laptop,
      content: 'Laptop',
      link:'laptop'
    },
    {
      id: 3,
      icon: tablet,
      content: 'Tablet',
      link:'tablet'
    },
    {
      id: 4,
      icon: phukien,
      content: 'Phụ kiện',
      link:'phu-kien'
    },
    {
      id: 5,
      icon: smartwatch,
      content: 'Smartwatch',
      link:'smart-watch'
    },
    {
      id: 6,
      icon: watch,
      content: 'Đồng hồ',
      link:'dong-ho'
    },
    {
      id: 7,
      icon: tv,
      content: 'TV',
      link:'tv'
    },  
    {
      id: 8,
      icon: smarthome,
      content: 'Nhà thông minh',
      link:'smart-home'
    }
      ]


export const feature_list_cate = [
        {
            title: 'Sạc dự phòng',
            link:'/sac-dtdd',
            name:'backupCharger',
            url: 'https://cdn.tgdd.vn/Category/57/5-Pinsa%CC%A3cdu%CC%9B%CC%A3pho%CC%80ng-120x120.png'
        },
        {
            title: 'Sạc, cáp',
            link:'/sac-cap',
            name:'chargeCable',
            url: 'https://cdn.tgdd.vn/Category/9518/10-Ca%CC%81psa%CC%A3cchuye%CC%82%CC%89ndo%CC%82%CC%89i-120x120.png'
        },
        {
            title: 'Tai nghe',
            link:'/tai-nghe',
            name:'headphone',
            url: 'https://cdn.tgdd.vn/Category/54/21-Tainghe-120x120.png'
        },
        {
            title: 'Loa',
            link:'/loa-laptop',
            name:'speaker',
            url: 'https://cdn.tgdd.vn/Category/2162/22-Loa2-120x120.png'
        },
        {
            title: 'Thiết bị nhà thông minh',
            link:'/khoa-dien-tu',
            name:'tech',
            url: 'https://cdn.tgdd.vn/Category/9458/thongminh-120x120.png'
        },
        {
            title: 'Camera, webcam',
            name:'camera',
            url: 'https://cdn.tgdd.vn/Category/4728/17-Camerawebcam-120x120.png'
        },
        {
            title: 'Thiết bị mạng',
            name:'wifi',
            url: 'https://cdn.tgdd.vn/Category/4727/16-Thie%CC%82%CC%81tbi%CC%A3ma%CC%A3ng-120x120.png'
        },
        {
            title: 'Ốp lưng, miếng dán',
            link:'/op-lung-flipcover',
            name:'bumper',
            url: 'https://cdn.tgdd.vn/Category/9262/icon-mieng-dan-op-lung-100x100-1.png'
        },
        {
            title: 'Chuột máy tính',
            name:'mouse',
            url: 'https://cdn.tgdd.vn/Category/86/13-Chuo%CC%A3%CC%82tma%CC%81yti%CC%81nh-120x120.png'
        },
        {
            title: 'Bàn phím',
            link:'/chuot-ban-phim',
            name:'keyBoard',
            url: 'https://cdn.tgdd.vn/Category/4547/19-Ba%CC%80nphi%CC%81m-120x120.png'
        },
    ]

export const list_brand=[
        {
            id:1,
            name:'apple',
            url:'https://cdn.tgdd.vn/Brand/1/Apple482-b_37.jpg'
        },
        {
            id:2,
            name:'beats',
            url:'https://cdn.tgdd.vn/Brand/1/Beats482-b_28.jpg'
        },
        {
            id:3,
            name:'harman',
            url:'https://cdn.tgdd.vn/Brand/1/Harman-Kardon482-b_23.jpg'
        },
        {
            id:4,
            name:'samsung',
            url:'https://cdn.tgdd.vn/Brand/1/samsungnew-220x48-220x48-1.png'
        },
        {
            id:5,
            name:'sony',
            url:'https://cdn.tgdd.vn/Brand/1/Sony482-b_41.jpg'
        },
        {
            id:6,
            name:'belkin',
            url:'https://cdn.tgdd.vn/Brand/1/Belkin9499-s39-160x40.jpg'
        },
        {
            id:7,
            name:'anker',
            url:'https://cdn.tgdd.vn/Brand/1/Anker482-b_18.png'
        },
        {
            id:8,
            name:'logitech',
            url:'https://cdn.tgdd.vn/Brand/1/Logitech482-b_47.jpg'
        },
        {
            id:9,
            name:'jbl',
            url:'https://cdn.tgdd.vn/Brand/1/JBL-220x48-1.jpeg'
        },
        {
            id:10,
            name:'xiaomi',
            url:'https://cdn.tgdd.vn/Brand/1/logo-xiaomi-220x48-14-220x48.png'
        },
        {
            id:11,
            name:'lg',
            url:'https://cdn.tgdd.vn/Brand/1/LG482-b_17.png'
        },
        {
            id:12,
            name:'asus',
            url:'https://cdn.tgdd.vn/Brand/1/Asus482-b_26.png'
        },
        {
            id:13,
            name:'jabra',
            url:'https://cdn.tgdd.vn/Brand/1/Jabra482-b_45.jpg'
        },
        {
            id:14,
            name:'oppo',
            url:'https://cdn.tgdd.vn/Brand/1/OPPO42-b5-220x48-6.jpg'
        },
        {
            id:15,
            name:'lg',
            url:'https://cdn.tgdd.vn/Brand/1/Mophie482-b_19.jpg'
        },
        {
            id:16,
            name:'microsoft',
            url:'https://cdn.tgdd.vn/Brand/1/Microsoft482-b_26.jpg'
        },
        {
            id:17,
            name:'corsair',
            url:'https://cdn.tgdd.vn/Brand/1/Corsair482-b_12.jpg'
        },
        {
            id:18,
            name:'philips',
            url:'https://cdn.tgdd.vn/Brand/1/Philips482-b_58.png'
        },
        {
            id:19,
            name:'genius',
            url:'https://cdn.tgdd.vn/Brand/1/Genius482-b_59.jpg'
        },
        {
            id:20,
            name:'zadez',
            url:'https://cdn.tgdd.vn/Brand/1/Zadez482-b_59.jpg'
        }
    ]

export const menu_apple_accessories = [
        {
            title: 'Nổi bật',
           
        },
        { 
            title:'Tai nghe',
           
        },
        {
            title:'Adapter sạc',
            
        },
        {
            title:'Cáp sạc',
           
        },
        {
            title:'Ốp lưng',
         
        },
    ]

export const menu_battery = [
        {
            title: 'Nổi bật',
            
        },
        { 
            title:'Dung lượng 10000mAh',
            
        },
        {
            title:'Dung lượng 20000mAh',
            
        },
        {
            title:'Dưới 300.000đ',
            
        },
        {
            title:'Xmobile',
           
        },    
    
    ]
    
    
export const menu_headphone = [
        {
            title: 'Nổi bật',
            cateId: 5,
            manufactureId:10,
        },
        { 
            title:'Bluetooth',
            cateId: 7,
            manufactureId:10,
        },
        {
            title:'Apple',
            cateId: 7,
            manufactureId:10,
        },
        {
            title:'Không dây True-Wireless',
            cateId: 7,
            manufactureId:10,
        },
        {
            title:'Sony',
            cateId: 7,
            manufactureId:10,
        },    
        
    ]
    
    
export const menu_chargeCable=[
        {
            title: 'Nổi bật',
            cateId: 5,
            manufactureId:10,
        },
        { 
            title:'Cáp lightning',
            cateId: 7,
            manufactureId:10,
        },
        {
            title:'Adapter sạc Type-C',
            cateId: 7,
            manufactureId:10,
        },
        {
            title:'Adapter sạc USB',
            cateId: 7,
            manufactureId:10,
        },
        {
            title:'Cáp Type-C',
            cateId: 7,
            manufactureId:10,
        },  
    ]
    
    
export const menu_speaker=[
        {
            title: 'Nổi bật',
            cateId: 5,
            manufactureId:10,
        },
        { 
            title:'Loa bluetooth',
            cateId: 7,
            manufactureId:10,
        },
        {
            title:'JBL',
            cateId: 7,
            manufactureId:10,
        },
        {
            title:'Harman Kardon',
            cateId: 7,
            manufactureId:10,
        },
        {
            title:'Sony',
            cateId: 7,
            manufactureId:10,
        },  
    ]
    
    
    
export const menu_smartHome = [
        {
            title: 'Nổi bật',
            cateId: 5,
            manufactureId:10,
        },
        { 
            title:'Khóa điện tử',
            cateId: 7,
            manufactureId:10,
        },
        {
            title:'Ổ cắm thông minh',
            cateId: 7,
            manufactureId:10,
        },
        {
            title:'TV Box',
            cateId: 7,
            manufactureId:10,
        },
        {
            title:'Router',
            cateId: 7,
            manufactureId:10,
        },  
    ]
    
    
export const menu_gaming = [
        {
            title: 'Nổi bật',
            cateId: 5,
            manufactureId:10,
        },
        { 
            title:'Chuột',
            cateId: 7,
            manufactureId:10,
        },
        {
            title:'Bàn phím',
            cateId: 7,
            manufactureId:10,
        },
        {
            title:'Tai nghe',
            cateId: 7,
            manufactureId:10,
        },
        {
            title:'Webcam',
            cateId: 7,
            manufactureId:10,
        },  
    ]



export const list_menu_cate_smart_watch = [
        {
            id:1,
            name:'deal',
            title:'Deal Sốc',
            url:'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/smartwatch/icon_donghothongminh@2x.png',
        },
        {
            id:2,
            name:'fashion',
            title:'Thời Trang',
            url:'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/smartwatch/icon_donghothongminh@2x.png',
        },
        {
            id:3,
            name:'utility',
            title:'Tiện Ích',
            url:'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/smartwatch/icon_donghothongminh@2x.png',
        },
        {
            id:4,
            name:'sport',
            title:'Thể Thao',
            url:'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/smartwatch/icon_donghothongminh@2x.png',
        },
        {
            id:5,
            name:'children',
            title:'Trẻ Em',
            url:'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/smartwatch/icon_donghothongminh@2x.png',
        },
        {
            id:6,
            name:'accessory',
            title:'Phụ Kiện',
            url:'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/smartwatch/icon_donghothongminh@2x.png',
        },
    ]

// smart watch

export const menu_fashion = [
    {
        title: 'Nổi bật',
        cateId: 5,
        manufactureId:10,
    },
    { 
        title:'Dưới 1 triệu',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Apple',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Samsung',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Xiaomi',
        cateId: 7,
        manufactureId:10,
    },  
    {
        title:'Amazfit',
        cateId: 7,
        manufactureId:10,
    },  
]

export const menu_utility = [
    {
        title: 'Nổi bật',
        cateId: 5,
        manufactureId:10,
    },
    { 
        title:'Chống nước',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Có nghe gọi',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Đo nồng độ Oxy',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Bộ nhớ lưu trữ nhạc',
        cateId: 7,
        manufactureId:10,
    },  
   
]

export const menu_sport = [
    {
        title: 'Nổi bật',
        cateId: 5,
        manufactureId:10,
    },
    { 
        title:'Chạy bộ',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Bơi lội',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Đạp xe',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Thể thao đa môn',
        cateId: 7,
        manufactureId:10,
    },  
    {
        title:'Garmin',
        cateId: 7,
        manufactureId:10,
    },  
    {
        title:'Suunto',
        cateId: 7,
        manufactureId:10,
    },  
]


export const menu_watch_chain = [
    {
        title: 'Nổi bật',
        cateId: 5,
        manufactureId:10,
    },
    { 
        title:'Apple',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Samsung',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Mi Band',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Dây silicon',
        cateId: 7,
        manufactureId:10,
    },  
    {
        title:'Dây da',
        cateId: 7,
        manufactureId:10,
    },  
]




    export const menu_healthycare = [
        {
            title: 'Nổi bật',
            
        },
        {
            title: 'Máy lọc không khí',
            
        },
        { 
            title:'Cân điện tử',
            
        },
           
    
    ]

    export const menu_home = [
        {
            title: 'Nổi bật',
            
        },
        { 
            title:'Máy hút bụi',
            
        },
        {
            title:'Đồ gia dụng',
            
        },
        {
            title:'Quạt',
            
        },
           
    
    ]

